<template>
  <img class="image-widget" :style="style" :src="widget.url" @load="onImageLoad" ref="img"/>
</template>

<script>
export default {
  name: 'ImageWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        borderRadius: this.widget.borderRadius,
      };
    },
  },
  methods: {
    onImageLoad() {
      // For the first time we load an image (usually just after creating it), if it doesn't have a width and a height
      // we will set it according to the natual size of the image
      if (!this.widget.height) {
        this.widget.height = this.$refs.img.naturalHeight;
      }
      if (!this.widget.width) {
        this.widget.width = this.$refs.img.naturalWidth;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-widget {
  position: absolute;
  display: flex;
}
</style>
